/**
 * Room Heading Watermark — auto-scale font size to fit container width.
 *
 * Starts at a base size (120px max) and scales down until the text
 * fits within its parent. The title always stays vertically centered
 * because the grid layout handles that automatically.
 *
 * @package villamarburg
 * @since 1.0.0
 */

export function initRoomWatermarks() {
    const MAX_FONT_SIZE = 120;
    const MIN_FONT_SIZE = 30;

    function fitWatermarks() {
        document.querySelectorAll('.room-heading__watermark').forEach(function (el) {
            const parent = el.closest('.room-heading');
            if (!parent) return;

            const containerWidth = parent.offsetWidth;
            let fontSize = MAX_FONT_SIZE;

            // Reset to max to measure natural width
            el.style.fontSize = fontSize + 'px';

            // Scale down until text fits
            while (el.scrollWidth > containerWidth && fontSize > MIN_FONT_SIZE) {
                fontSize -= 2;
                el.style.fontSize = fontSize + 'px';
            }
        });
    }

    // Run on load and resize
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', fitWatermarks);
    } else {
        fitWatermarks();
    }

    let resizeTimer;
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(fitWatermarks, 100);
    });
}
